import React from "react";
import styles from "./SHProducts.module.scss";
import { ImageCarousel } from "./ImageCarousel";
import { MaterialCard } from "./MaterialCard";
import { VideoCard } from "./VideoCard";
import { parseLines } from "../../../../utils";

export const ProductDetailView = ({ product, onBack, onMaterialClick, onRequestMoreInfo, successMessage, loading }) => {
  const {
    productFamilyimage,
    productFamilyDesc,
    productCategory,
    isFormularyProduct,
    manufacturer,
    productFamilyCoreDesc,
    keyBenefits,
    videos = [],
    materials = [],
    materialCount,
  } = product;

  const images = (productFamilyimage || []).map((img) => img.image).filter(Boolean);
  const descriptionLines = parseLines(productFamilyCoreDesc);
  const benefitLines = parseLines(keyBenefits);
  const isFormulary = isFormularyProduct === 1;
  const skuCount = materialCount ?? materials.length;

  return (
    <div className={styles.detail_view}>
      <button type="button" className={styles.back_link} onClick={onBack}>
        ‹ Back
      </button>

      <ImageCarousel images={images} altText={productFamilyDesc} />

      <div className={styles.detail_header}>
        <h3 className={styles.detail_title}>{productFamilyDesc || "—"}</h3>
        <p className={styles.detail_category}>{productCategory || "—"}</p>
        <p className={styles.formulary_row}>
          Formulary Item: <span className={styles.formulary_yes_no}>{isFormulary ? "Yes" : "No"}</span>
        </p>
      </div>

      <div className={styles.divider} />

      <div className={styles.manufacturer_row}>
        <span>
          Manufacturer: <span className={styles.manufacturer_text}>{manufacturer}</span>
        </span>
      </div>

      <div className={styles.divider} />

      {descriptionLines.length > 0 && (
        <div className={styles.section}>
          <h4 className={styles.section_title}>Description</h4>
          {descriptionLines.map((line, idx) => (
            <p key={idx} className={styles.section_text}>
              {line}
            </p>
          ))}
        </div>
      )}

      {benefitLines.length > 0 && (
        <div className={styles.section}>
          <h4 className={styles.section_title}>Key Benefits</h4>
          <ul className={styles.benefits_list}>
            {benefitLines.map((line, idx) => (
              <li key={idx}>{line}</li>
            ))}
          </ul>
        </div>
      )}

      {videos.length > 0 && (
        <div className={styles.section}>
          <h4 className={styles.section_title}>Videos</h4>
          <div className={styles.videos_list}>
            {videos.map((video, idx) => (
              <VideoCard key={video.videoUrl || idx} video={video} />
            ))}
          </div>
        </div>
      )}

      <div className={styles.section}>
        <h4 className={styles.section_title}>{skuCount} SKUs in Product Family</h4>
        {materials.length > 0 ? (
          <div className={styles.materials_list}>
            {materials.map((material) => (
              <MaterialCard key={material.materialId || material.materialNumber} material={material} onClick={onMaterialClick} />
            ))}
          </div>
        ) : (
          <p className={styles.section_text}>No SKU information available for this product.</p>
        )}
      </div>

      <div className={styles.divider} />

      {successMessage && (
        <div className={styles.successBanner}>
          <div>Thank you for reaching out to us!</div>
          <div>{successMessage}</div>
        </div>
      )}

      <div className={styles.footer}>
        <p>Have a question? We're here to help!</p>
        <button type="button" className={styles.request_info_btn} onClick={() => onRequestMoreInfo("family", isFormularyProduct)}>
          {loading && <span data-testid="loading-spinner" className={styles.custom_spinner}></span>}
          Request more info
        </button>
      </div>
    </div>
  );
};
